import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    brand: {
      id: null,
      description: 'Inmuebles en 9 de Julio',
  	  ManyEmpresaImage: [
  		  {description_source: './assets/logo.png'}
  	  ]
  	},
	brand_ready: false
  },
  actions: {

  },
  mutations: {
    brand: function (state, payload) {
      state.brand = payload;
  	  state.brand_ready = 1;
    },
	  defaultBrand: function (state, payload) {
      console.log('set default brand');
      state.brand_ready = payload;
  	}
  },
  getters: {
    brand: state => {
      return state.brand
  	},
    brandReady: state => {
      return state.brand_ready
  	},
  }
});


export default store;



// WEBPACK FOOTER //
// ./src/store.js